/**
 * Repository Constants
 * Shared configuration for Repository feature across CSRD and BRSR
 */

export const CATEGORY_OPTIONS = [
  { label: "General", value: "General" },
  { label: "Policy", value: "Policy" },
  { label: "Governance structure", value: "Governance structure" },
  { label: "Governance document", value: "Governance document" },
  { label: "Annual Report", value: "Annual Report" },
  { label: "ESG/Sustainability Report", value: "ESG/Sustainability Report" },
  { label: "GRI Report", value: "GRI Report" },
  { label: "SASB Report", value: "SASB Report" },
  { label: "CDP Report", value: "CDP Report" },
  { label: "TCFD Report", value: "TCFD Report" },
  { label: "Integrated Report", value: "Integrated Report" },
  { label: "ESG Strategy", value: "ESG Strategy" },
  { label: "Roadmap", value: "Roadmap" },
];

export const DEFAULT_CATEGORY = "General";

export const API_ENDPOINTS = {
  LIST_REPOSITORY: "list-repository-new",
  DELETE_FILE: "delete-repository-file-new",
  ADD_FILES: "add-files",
  ADD_LINKS: "add-links",
  GET_REPO_STATUS: "get-csrd-status",
  GET_SAS_TOKEN: "GetSASToken",
};

export const AZURE_CONFIG = {
  CONTAINER_NAME: "ecoprismfilecontainer",
  BLOCK_SIZE: 4 * 1024 * 1024, // 4MB
  CONCURRENCY: 20,
};
